import React from 'react';
import {Router} from "@reach/router"

import Login from './pages/Login'
import Home from "./pages/Home";

const App = () => (
  <Router>
    <Home path="/"/>
    <Login path="/login"/>
  </Router>
);

export default App;
